import { Waves, Rabbit, UtensilsCrossed, TreePine, Footprints, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "./Chapter";
import { IMAGES } from "../lib/data";

const PLUS = [
  { icon: Waves, title: "Lac de Bannac", text: "baignade & pêche à deux pas" },
  { icon: Rabbit, title: "Mini-ferme", text: "et Dino, notre mascotte" },
  { icon: UtensilsCrossed, title: "La Table de Bannac", text: "restaurant ouvert en été" },
  { icon: TreePine, title: "Nature préservée", text: "150 emplacements en plein vert" },
];

const STATS = [
  ["150", "emplacements"],
  ["4", "étoiles"],
  ["437", "avis Google"],
];

export default function LeCamping() {
  return (
    <section id="camping" className="relative py-28 lg:py-36 px-6 sm:px-10 lg:px-16 grain" data-testid="section-camping">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Chapter num="1" label="Le camping" />
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl leading-[1.05] tracking-tight text-ink">
                Entre lac, forêt<br />
                et bastides,<br />
                <span className="italic font-medium text-pine">la douceur de vivre.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-ink/70 text-base lg:text-lg leading-relaxed">
                À Martiel, dans un cadre naturel préservé aux portes du lac de Bannac,
                notre camping 4 étoiles vous accueille en famille, en couple ou entre amis.
                Ici, on ralentit, on profite, on respire : piscine couverte chauffée,
                mini-ferme, hébergements tout équipés et animations douces.
              </p>
              <p className="mt-4 font-hand text-2xl text-terra -rotate-2">
                l'Aveyron vous tend les bras !
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-10 flex divide-x divide-ink/10">
                {STATS.map(([n, label]) => (
                  <div key={label} className="pr-8 pl-8 first:pl-0">
                    <div className="font-display font-black text-4xl text-pine">{n}</div>
                    <div className="text-xs tracking-[0.18em] uppercase text-ink/50 font-semibold mt-1">{label}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7 relative">
          <Reveal className="relative z-10 w-[78%] -rotate-2" delay={0.15}>
            <img
              src={IMAGES.nature}
              alt="Nature au bord du lac, camping en Aveyron"
              className="rounded-[2rem] shadow-2xl shadow-ink/20 w-full h-[420px] object-cover"
            />
          </Reveal>
          <Reveal className="relative z-20 w-[52%] ml-auto -mt-24 rotate-3" delay={0.3}>
            <img
              src={IMAGES.martiel}
              alt="Le camping à Martiel, Aveyron"
              className="rounded-[2rem] border-8 border-sand shadow-2xl shadow-ink/25 w-full h-72 object-cover"
            />
          </Reveal>
          <Reveal delay={0.4} className="relative z-30 w-max ml-8 -mt-6">
            <span className="font-hand text-3xl text-lake rotate-[-3deg] inline-block">
              ici, on se reconnecte à l'essentiel
            </span>
          </Reveal>

          <div className="mt-16 grid sm:grid-cols-2 gap-4">
            {PLUS.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.08}>
                <div
                  className="group flex items-start gap-4 rounded-2xl border border-ink/10 bg-cream/60 p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-pine/10 hover:border-pine/30"
                  data-testid={`plus-${i}`}
                >
                  <span className="grid place-items-center w-11 h-11 shrink-0 rounded-full bg-pine text-sand transition-transform duration-300 group-hover:-rotate-12">
                    <p.icon size={19} />
                  </span>
                  <div>
                    <div className="font-display font-bold text-lg text-ink">{p.title}</div>
                    <div className="text-sm text-ink/60 mt-0.5">{p.text}</div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.4}>
            <Link
              to="/randonnees"
              data-testid="camping-rando-link"
              className="group mt-6 flex items-center justify-between gap-4 rounded-2xl bg-pine text-sand p-6 transition-all duration-300 hover:bg-pinedark hover:-translate-y-1 hover:shadow-xl hover:shadow-pine/25"
            >
              <div className="flex items-center gap-4">
                <span className="grid place-items-center w-12 h-12 shrink-0 rounded-full bg-gold text-pinedark transition-transform duration-300 group-hover:-rotate-12">
                  <Footprints size={22} />
                </span>
                <div>
                  <div className="font-display font-bold text-xl">7 randonnées au départ du camping</div>
                  <p className="text-sm text-sand/70 mt-0.5">
                    Itinéraires, durées et niveaux — de la boucle famille à la grande boucle du lac.
                  </p>
                </div>
              </div>
              <ArrowUpRight size={22} className="text-gold shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
